var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 118,
    viewBox: "0 0 171 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.896L75.4678 118L132.411 85.2091L171 62.0702L96.8535 17.2159",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.896L75.6543 116.113L128.399 84.8519L168.89 45.7754L95.8998 0L59.1382 35.1689L0 70.896Z",
    fill: "#FFF3D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90466 69.8521L76.3734 111.368L124.808 82.6637L161.991 46.7802L94.9619 4.74503L61.2106 37.0446L6.90466 69.8521Z",
    fill: "#68E1FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.9618 4.74503L61.2104 37.0446L124.808 82.6636L161.99 46.7802L94.9618 4.74503Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.721 39.0877L138.032 49.2252L107.839 41.4713L56.4529 76.2885L52.4997 97.0996L44.7958 92.4997L50.342 72.1297L105.852 32.4223L135.65 40.9075L141.889 34.1752",
    fill: "#F9EFD7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.93 37.3349L145.88 38.1946",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.923 40.6173L139.337 43.5536",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.63 5.08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.856 44.765L136.812 45.6247L135.533 45.2228",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.097 44.1397L110.232 37.2566",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.47 4.86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.511 36.7152L107.238 36.3133L106.146 37.1171",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.917 39.4841L82.3944 54.5341",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.81 5.34"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7794 55.7175L79.6873 56.5158",
    stroke: "#F7931E",
    strokeWidth: 2.16443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7657 61.1213C83.5913 61.1213 87.5033 59.2743 87.5033 56.996C87.5033 54.7176 83.5913 52.8706 78.7657 52.8706C73.9401 52.8706 70.0282 54.7176 70.0282 56.996C70.0282 59.2743 73.9401 61.1213 78.7657 61.1213Z",
    stroke: "#39B54A",
    strokeWidth: 1.44295,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0247 25.1318C94.0247 24.9643 94.014 24.7987 93.9927 24.635C93.5718 19.2257 90.1301 14.5197 85.4949 12.2365C83.6066 11.3173 81.5461 10.8519 79.4641 10.8745C77.3821 10.897 75.3313 11.4069 73.4616 12.3669C71.5918 13.3269 69.9506 14.7127 68.6579 16.4229C67.3651 18.1331 66.4536 20.1245 65.99 22.2513C64.9244 27.3815 66.6559 32.5787 68.462 37.2958C71.262 44.6532 74.8873 51.6355 79.2614 58.0957C81.6049 54.7015 83.778 51.1817 85.7719 47.5506C89.5866 40.7401 94.4775 33.3769 94.0247 25.1318Z",
    fill: "#E55151"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7037 34.9568C84.3969 34.9568 88.2015 30.9704 88.2015 26.0529C88.2015 21.1354 84.3969 17.149 79.7037 17.149C75.0105 17.149 71.2059 21.1354 71.2059 26.0529C71.2059 30.9704 75.0105 34.9568 79.7037 34.9568Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3768 47.8799L105.852 71.0858H136.806L133.796 73.9887H104.062L95.8248 49.6105",
    fill: "#F9EFD7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9622 4.74503L105.852 32.4224L109.789 33.5444L99.2936 7.46364L94.9622 4.74503Z",
    fill: "#F9EFD7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4294 52.1448L57.8274 67.608L60.6458 64.761L37.9708 50.2636",
    fill: "#F9EFD7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4284 76.3053C18.2313 76.6402 45.6 59.2009 45.6 59.2009L67.9767 43.8996L66.032 32.439L64.8599 33.5555L66.6607 43.3805L16.6223 75.6577",
    fill: "#F9EFD7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4342 65.3806C30.9353 65.3806 32.9628 64.4084 32.9628 63.2091C32.9628 62.0098 30.9353 61.0376 28.4342 61.0376C25.9332 61.0376 23.9056 62.0098 23.9056 63.2091C23.9056 64.4084 25.9332 65.3806 28.4342 65.3806Z",
    fill: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4532 76.3053C56.4532 76.3053 85.0367 70.7955 92.6821 83.8192C100.327 96.8428 94.9464 100.371 94.9464 100.371L99.8106 97.4848C99.8106 97.4848 100.066 82.0161 85.8092 75.6745C71.5521 69.333 59.1704 73.0285 59.1704 73.0285",
    fill: "#F9EFD7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M60.3578 101.8C60.6615 101.644 69.1966 98.4841 69.1966 98.4841L70.7949 101.487L65.6056 104.954L60.3578 101.8Z",
    fill: "url(#paint0_linear_7_218)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M73.3318 104.614C73.6355 104.457 85.0529 100.081 85.0529 100.081L86.3369 101.482L78.1214 107.862L73.3318 104.614Z",
    fill: "url(#paint1_linear_7_218)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M65.2551 94.8946C65.74 94.6434 78.127 90.0491 78.127 90.0491L79.6721 92.7007L70.2259 100.081L65.2551 94.8946Z",
    fill: "url(#paint2_linear_7_218)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.032 74.5413H78.5099C77.9184 74.5413 77.439 75.0437 77.439 75.6634V91.9359C77.439 92.5556 77.9184 93.058 78.5099 93.058H79.032C79.6234 93.058 80.1028 92.5556 80.1028 91.9359V75.6634C80.1028 75.0437 79.6234 74.5413 79.032 74.5413Z",
    fill: "#BC532A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3505 78.3317C84.7378 75.5406 82.0046 63.2259 77.167 66.8432C74.6896 68.6966 73.9704 71.5938 72.9954 74.4297C72.0951 76.7676 71.5747 79.2469 71.4557 81.7649C71.3757 86.8895 76.3519 87.5147 80.1559 87.498C82.3509 87.498 85.4837 86.1303 86.0165 83.635C86.3255 82.1277 85.798 80.3526 85.4837 78.8788L85.3505 78.3317Z",
    fill: "#2C9135"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.585 78.8732L85.4678 78.315C84.935 75.842 82.724 65.9333 78.8773 66.1734C80.0175 71.3984 81.7064 76.9194 80.806 82.2673C80.5184 84.1339 79.8218 85.9052 78.7708 87.4422C79.3035 87.4422 79.7884 87.4756 80.2732 87.4756C82.4682 87.4756 85.601 86.108 86.1337 83.6126C86.4161 82.1277 85.8887 80.347 85.585 78.8732Z",
    fill: "#156819"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4305 88.9884H85.4252C84.9132 88.9884 84.4982 89.4233 84.4982 89.9598V100.929C84.4982 101.466 84.9132 101.9 85.4252 101.9H85.4305C85.9425 101.9 86.3576 101.466 86.3576 100.929V89.9598C86.3576 89.4233 85.9425 88.9884 85.4305 88.9884Z",
    fill: "#BC532A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0175 91.629C89.5859 89.6807 87.6839 81.095 84.3114 83.6183C82.5852 84.9134 82.0951 86.9286 81.4025 88.9048C80.7775 90.535 80.4174 92.2634 80.3369 94.0182C80.2836 97.5909 83.752 98.0263 86.4052 98.0152C87.9343 98.0152 90.1347 97.0606 90.4756 95.3189C90.6888 94.2694 90.3265 93.0301 90.108 92.003L90.0175 91.629Z",
    fill: "#2C9135"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1778 92.0086L90.0979 91.629C89.7196 89.904 88.1852 82.9931 85.5054 83.1661C86.3045 86.8114 87.4767 90.6576 86.848 94.3867C86.6485 95.6892 86.1634 96.9256 85.4308 97.9985H86.4963C88.0254 97.9985 90.2258 97.0439 90.5668 95.3022C90.7586 94.275 90.3909 93.0525 90.1778 92.0086Z",
    fill: "#156819"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9797 84.1988H69.5748C68.9834 84.1988 68.5039 84.7011 68.5039 85.3208V100.778C68.5039 101.398 68.9834 101.9 69.5748 101.9H69.9797C70.5711 101.9 71.0506 101.398 71.0506 100.778V85.3208C71.0506 84.7011 70.5711 84.1988 69.9797 84.1988Z",
    fill: "#BC532A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.075 87.8218C75.4889 85.1534 72.8783 73.3802 68.2538 76.8413C65.883 78.6109 65.2117 81.3853 64.2686 84.0983C63.4067 86.3328 62.9079 88.7027 62.7929 91.1098C62.7183 96.0055 67.4706 96.6084 71.1095 96.5861C73.2086 96.5861 76.1975 95.2798 76.6877 92.8905C76.9807 91.4503 76.4799 89.7533 76.1869 88.3465L76.075 87.8218Z",
    fill: "#2C9135"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2937 88.3409L76.1818 87.8217C75.6491 85.4604 73.5606 75.9815 69.8844 76.216C70.9766 81.2122 72.5856 86.4875 71.7278 91.601C71.454 93.3869 70.7883 95.0819 69.7832 96.5525C70.2734 96.5525 70.7529 96.586 71.2164 96.586C73.3155 96.586 76.3044 95.2797 76.7945 92.8905C77.0929 91.4447 76.5868 89.7476 76.2937 88.3409Z",
    fill: "#156819"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M116.129 63.5105C112.72 64.8168 107.765 66.7204 107.562 66.8265L112.357 70.0754L117.887 65.7826C117.152 65.1663 116.553 64.3914 116.129 63.5105Z",
    fill: "url(#paint3_linear_7_218)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M117.84 65.9835L117.904 65.9109V43.0232H115.048V65.9444C115.452 66.2525 115.938 66.4216 116.438 66.4286C116.938 66.4356 117.427 66.2801 117.84 65.9835Z",
    fill: "#D3894C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116.475 50.8721L111.749 53.8866L110.098 52.8817L110.774 50.6488L115.351 47.8632L116.475 50.8721Z",
    fill: "#D3894C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M115.352 48.4326L111.201 51.0284L110.461 53.1051L111.75 53.8866L115.277 51.6369L115.352 48.4326Z",
    fill: "#C66B28"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M116.785 45.8702L120.728 43.6875L122.529 44.8542L120.728 46.8137L117.989 47.4556",
    fill: "#D3894C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.839 65.9835L117.903 65.9109V43.0232H116.625V66.4189C117.06 66.3916 117.48 66.2411 117.839 65.9835Z",
    fill: "#C66B28"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M116.625 46.6797L121.548 44.1007L122.528 44.8543L122.155 46.4229L117.376 49.2532",
    fill: "#C66B28"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.476 43.7936C117.264 43.7936 117.904 43.4537 117.904 43.0344C117.904 42.6151 117.264 42.2752 116.476 42.2752C115.687 42.2752 115.048 42.6151 115.048 43.0344C115.048 43.4537 115.687 43.7936 116.476 43.7936Z",
    fill: "#EAA068"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M16.1696 66.8153C16.4732 66.659 27.8906 62.2824 27.8906 62.2824L29.1746 63.6836L20.9752 70.0754L16.1696 66.8153Z",
    fill: "url(#paint4_linear_7_218)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2598 63.6278L29.2971 63.5553V40.6676H27.5709V63.5888C27.6618 63.7349 27.7852 63.8556 27.9307 63.9404C28.0761 64.0252 28.2391 64.0716 28.4055 64.0754C28.5719 64.0793 28.7367 64.0405 28.8856 63.9625C29.0345 63.8845 29.1629 63.7696 29.2598 63.6278Z",
    fill: "#E6E6E6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2603 63.6278L29.2976 63.5553V40.6676H28.525V64.0633C28.8137 64.0205 29.0764 63.8649 29.2603 63.6278Z",
    fill: "#B3B3B3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.434 41.4379C28.9107 41.4379 29.2971 41.098 29.2971 40.6787C29.2971 40.2594 28.9107 39.9195 28.434 39.9195C27.9573 39.9195 27.5709 40.2594 27.5709 40.6787C27.5709 41.098 27.9573 41.4379 28.434 41.4379Z",
    fill: "#DDDAA5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4561 42.5262C34.1804 39.3031 32.5781 36.1501 29.8772 35.4838C27.1764 34.8174 24.3997 36.89 23.6754 40.1131C22.9511 43.3361 24.5534 46.4891 27.2542 47.1555C29.9551 47.8218 32.7317 45.7492 33.4561 42.5262Z",
    fill: "#CA4050"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7591 42.3943C33.358 39.7294 32.0325 37.1223 29.7985 36.5711C27.5645 36.0199 25.268 37.7334 24.6691 40.3983C24.0702 43.0632 25.3957 45.6703 27.6297 46.2215C29.8638 46.7726 32.1603 45.0591 32.7591 42.3943Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0604 36.7877L26.1216 45.4236C26.1216 45.4236 26.8888 47.5449 27.267 46.6127C27.6453 45.6804 32.2645 37.7144 32.2645 37.7144L31.0604 36.7877Z",
    fill: "#CA4050"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M46.8529 50.2636C43.4432 51.5698 38.4883 53.4734 38.2859 53.5795L42.6387 56.5214L47.8386 51.7596C47.1033 51.14 47.2792 51.1456 46.8529 50.2636Z",
    fill: "url(#paint5_linear_7_218)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M56.0268 57.236C52.617 58.5422 47.6622 60.4458 47.4597 60.5519L51.8125 63.4938L57.0124 58.7321C56.2718 58.118 56.453 58.118 56.0268 57.236Z",
    fill: "url(#paint6_linear_7_218)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M55.169 45.5242C51.7592 46.8305 46.8044 48.7341 46.6019 48.8401L50.9547 51.782L56.1546 47.0203C55.4141 46.4062 55.5952 46.4062 55.169 45.5242Z",
    fill: "url(#paint7_linear_7_218)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3217 54.2717C57.3217 53.6952 56.8756 53.2278 56.3254 53.2278C55.7752 53.2278 55.3291 53.6952 55.3291 54.2717V58.1347C55.3291 58.7113 55.7752 59.1786 56.3254 59.1786C56.8756 59.1786 57.3217 58.7113 57.3217 58.1347V54.2717Z",
    fill: "#BC532A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3251 57.2359C58.4378 57.2359 60.1504 55.4414 60.1504 53.2278C60.1504 51.0142 58.4378 49.2197 56.3251 49.2197C54.2124 49.2197 52.4998 51.0142 52.4998 53.2278C52.4998 55.4414 54.2124 57.2359 56.3251 57.2359Z",
    fill: "#9CD861"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3246 49.2197C56.1085 49.2211 55.8928 49.2416 55.68 49.2811C56.4531 49.7374 57.0796 50.424 57.4798 51.2539C57.8801 52.0837 58.0362 53.0194 57.9283 53.9423C57.8409 54.657 57.5689 55.3332 57.1417 55.8979C56.7145 56.4625 56.1483 56.8943 55.5042 57.1466C56.0294 57.2685 56.5733 57.273 57.1003 57.1597C57.6273 57.0464 58.1256 56.818 58.5626 56.4892C58.9996 56.1605 59.3655 55.7388 59.6364 55.2518C59.9073 54.7649 60.0772 54.2235 60.1348 53.663C60.1925 53.1026 60.1367 52.5357 59.9711 51.9994C59.8055 51.4631 59.5338 50.9694 59.1737 50.5506C58.8136 50.1318 58.3733 49.7973 57.8814 49.5689C57.3896 49.3405 56.8573 49.2234 56.3193 49.2252L56.3246 49.2197Z",
    fill: "#54BA56"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8413 44.9325H46.3458C45.7955 44.9325 45.3495 45.3999 45.3495 45.9764V51.3299C45.3495 51.9064 45.7955 52.3738 46.3458 52.3738H46.8413C47.3915 52.3738 47.8376 51.9064 47.8376 51.3299V45.9764C47.8376 45.3999 47.3915 44.9325 46.8413 44.9325Z",
    fill: "#BC532A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5909 49.9454C49.2332 49.9454 51.3752 47.701 51.3752 44.9324C51.3752 42.1638 49.2332 39.9195 46.5909 39.9195C43.9485 39.9195 41.8065 42.1638 41.8065 44.9324C41.8065 47.701 43.9485 49.9454 46.5909 49.9454Z",
    fill: "#9CD861"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6072 39.9195C46.3374 39.9218 46.0683 39.9479 45.8027 39.9976C46.77 40.5676 47.5538 41.4259 48.0547 42.4636C48.5555 43.5013 48.7508 44.6715 48.6157 45.8256C48.506 46.7187 48.1657 47.5635 47.6315 48.2689C47.0973 48.9742 46.3894 49.5134 45.5842 49.8282C46.2467 49.9947 46.9354 50.0113 47.6044 49.8771C48.2735 49.7428 48.9076 49.4607 49.4645 49.0496C50.0214 48.6385 50.4882 48.1077 50.834 47.4927C51.1798 46.8777 51.3965 46.1926 51.4698 45.4829C51.543 44.7733 51.4711 44.0554 51.2589 43.3772C51.0466 42.6989 50.6989 42.0758 50.2388 41.5494C49.7787 41.023 49.2168 40.6054 48.5906 40.3244C47.9644 40.0433 47.2883 39.9053 46.6072 39.9195Z",
    fill: "#54BA56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5071 42.3645C56.5071 41.788 56.0611 41.3206 55.5108 41.3206C54.9606 41.3206 54.5145 41.788 54.5145 42.3645V46.2275C54.5145 46.804 54.9606 47.2714 55.5108 47.2714C56.0611 47.2714 56.5071 46.804 56.5071 46.2275V42.3645Z",
    fill: "#BC532A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5045 45.3288C57.6172 45.3288 59.3299 43.5343 59.3299 41.3207C59.3299 39.107 57.6172 37.3125 55.5045 37.3125C53.3919 37.3125 51.6792 39.107 51.6792 41.3207C51.6792 43.5343 53.3919 45.3288 55.5045 45.3288Z",
    fill: "#9CD861"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5055 37.3125C55.2894 37.3139 55.0737 37.3345 54.8609 37.3739C55.634 37.8303 56.2605 38.5169 56.6607 39.3468C57.061 40.1766 57.2171 41.1123 57.1092 42.0352C57.0218 42.7499 56.7498 43.4261 56.3226 43.9907C55.8954 44.5554 55.3292 44.9872 54.6851 45.2395C55.2103 45.3614 55.7542 45.3659 56.2812 45.2526C56.8082 45.1393 57.3065 44.9109 57.7435 44.5821C58.1805 44.2533 58.5464 43.8317 58.8173 43.3447C59.0882 42.8577 59.2581 42.3163 59.3158 41.7559C59.3734 41.1955 59.3176 40.6286 59.152 40.0923C58.9864 39.556 58.7147 39.0623 58.3546 38.6435C57.9945 38.2247 57.5542 37.8902 57.0623 37.6618C56.5705 37.4334 56.0382 37.3163 55.5002 37.3181L55.5055 37.3125Z",
    fill: "#54BA56"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M77.791 55.1593C72.0903 57.5709 63.8056 61.0934 63.47 61.2999L70.7424 66.7315L79.4373 57.9393C78.2066 56.767 78.4996 56.767 77.791 55.1593Z",
    fill: "url(#paint8_linear_7_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_218",
    x1: 63.4372,
    y1: 103.419,
    x2: 71.7849,
    y2: 97.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_218",
    x1: 78.6276,
    y1: 104.563,
    x2: 89.3798,
    y2: 98.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_218",
    x1: 69.4481,
    y1: 96.3739,
    x2: 78.0458,
    y2: 91.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_218",
    x1: 110.306,
    y1: 68.2221,
    x2: 121.113,
    y2: 61.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_218",
    x1: 18.4072,
    y1: 68.5737,
    x2: 31.9915,
    y2: 59.2278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_218",
    x1: 40.8592,
    y1: 54.7797,
    x2: 51.3547,
    y2: 48.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_218",
    x1: 50.033,
    y1: 61.7577,
    x2: 60.5285,
    y2: 55.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_218",
    x1: 49.1752,
    y1: 50.0459,
    x2: 59.6707,
    y2: 43.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_218",
    x1: 67.908,
    y1: 63.4603,
    x2: 85.683,
    y2: 52.6136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapa);
export default __webpack_public_path__ + "static/media/mapa.1706f25cd94e884f1352e53f4a04490f.svg";
export { ForwardRef as ReactComponent };